import type { QueryHookOptions } from "@apollo/client";
/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
import { gql, useQuery } from "@apollo/client";

const WordpressHomeSlides_Emerson_Query = gql`
  query WordpressHomeSlides_Emerson_Query {
    homeSlides(where: { orderby: { field: DISPLAYORDER_HS, order: ASC } }) {
      nodes {
        homeSlideActionUrl
        homeSlideActionText
        homeSlideDisplayOrder
        homeSlideImage
        homeSlideText
        title
      }
    }
  }
`;

export type WordpressHomeSlidesType = {
  homeSlideActionUrl: string;
  homeSlideActionText: string;
  homeSlideDisplayOrder: number;
  homeSlideImage: string;
  homeSlideText: string;
  title: string;
};

export type WordpressHomeSlidesResults = {
  homeSlides?: {
    nodes?: WordpressHomeSlidesType[];
  };
};

const useWordpressHomeSlidesQuery = (options?: QueryHookOptions<WordpressHomeSlidesResults>) =>
  useQuery<WordpressHomeSlidesResults>(WordpressHomeSlides_Emerson_Query, {
    context: { clientName: "wordpress" },
    ...options,
  });

export { useWordpressHomeSlidesQuery, WordpressHomeSlides_Emerson_Query };
